import React, { Fragment, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PageTitle from "../layouts/PageTitle";
import { Formik } from "formik";
import * as Yup from "yup";
import { Fn_AddEditData, Fn_DisplayData, Fn_FillListData, Fn_DeleteData } from "../../store/Functions";
import { useDispatch } from "react-redux";
import { API_WEB_URLS } from "../../constants/constAPI";
import { toast } from "react-toastify";
import useSession from "../utils/useSession";

const DesignationSchema = Yup.object().shape({
  F_WorkerCategory: Yup.string().required("Worker Category is required"),
  Name: Yup.string().required("Designation name is required"),
});

const AddEdit_DesignationMaster = () => {
  const { firmId: sessionFirmId } = useSession();
  const defaultFirmId = sessionFirmId ? String(sessionFirmId) : "";

  const [state, setState] = useState({
    id: 0,
    formData: {
      Name: "",
      F_FirmMaster: defaultFirmId,
      F_WorkerCategory: "",
      IsNotInUse: false,
    },
    FirmMaster: [],
    WorkerCategory: [],
    isProgress: false,
  });

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const API_URL_SAVE = "DesignationMaster/0/token";
  const API_URL_EDIT = `${API_WEB_URLS.MASTER}/0/token/DesignationMaster/Id`;

  useEffect(() => {
    Fn_FillListData(dispatch, setState, "FirmMaster", `${API_WEB_URLS.MASTER}/0/token/FirmMaster/Id/0`);
    Fn_FillListData(dispatch, setState, "WorkerCategory", `${API_WEB_URLS.MASTER}/0/token/WorkerCategory/Id/0`);

    const Id = (location.state && location.state.Id) || 0;
    if (Id > 0) {
      setState((prev) => ({ ...prev, id: Id }));
      Fn_DisplayData(dispatch, setState, Id, API_URL_EDIT);
    } else {
      setState((prev) => ({
        ...prev,
        formData: {
          ...prev.formData,
          F_FirmMaster: defaultFirmId,
        },
      }));
    }
  }, [dispatch, location.state, defaultFirmId]);

  const handleSubmit = async (values) => {
    try {
      const formData = new FormData();
      formData.append("Name", values.Name);
      formData.append("F_FirmMaster", values.F_FirmMaster || defaultFirmId || 0);
      formData.append("F_WorkerCategory", values.F_WorkerCategory);
      formData.append("IsNotInUse", values.IsNotInUse ? true : false);

      Fn_AddEditData(
        dispatch,
        setState,
        { arguList: { id: state.id, formData } },
        API_URL_SAVE,
        true,
        "memberid",
        navigate,
        "/DesignationMaster"
      );
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("An error occurred while submitting the form. Please try again.");
    }
  };

  return (
    <Fragment>
      <PageTitle activeMenu="Masters" motherMenu="Masters" pageContent="Designation Master" />

      <div className="row">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Designation Master</h4>
            </div>
            <div className="card-body">
              <div className="basic-form">
                <Formik
                  initialValues={state.formData || {
                    Name: "",
                    F_FirmMaster: defaultFirmId,
                    F_WorkerCategory: "",
                    IsNotInUse: false,
                  }}
                  enableReinitialize
                  validationSchema={DesignationSchema}
                  onSubmit={(values, { setSubmitting }) => {
                    setTimeout(() => {
                      handleSubmit(values);
                      setSubmitting(false);
                    }, 400);
                  }}
                >
                  {({ values = {}, errors, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue }) => (
                    <form onSubmit={handleSubmit}>
                      <div className="row">
                        <div className="col-md-6 mb-3">
                          <label className="text-label">Worker Category *</label>
                          <select
                            className="form-control"
                            name="F_WorkerCategory"
                            value={values.F_WorkerCategory}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          >
                            <option value="">-- Select Worker Category --</option>
                            {state.WorkerCategory.map((w) => <option key={w.Id} value={w.Id}>{w.Name}</option>)}
                          </select>
                          {errors.F_WorkerCategory && <div className="text-danger fs-12">{errors.F_WorkerCategory}</div>}
                        </div>

                        <div className="col-md-6 mb-3">
                          <label className="text-label">Designation Name *</label>
                          <input
                            type="text"
                            className="form-control"
                            name="Name"
                            value={values.Name}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          {errors.Name && <div className="text-danger fs-12">{errors.Name}</div>}
                        </div>

                        <div className="col-md-6 mb-3">
                          <label className="text-label">
                            Firm {defaultFirmId ? <span className="badge bg-light text-success ms-1 border" style={{ fontSize: "11px" }}>🔒 Header Locked</span> : null}
                          </label>
                          <select
                            className="form-control"
                            name="F_FirmMaster"
                            value={values.F_FirmMaster || defaultFirmId}
                            disabled={!!defaultFirmId}
                            style={defaultFirmId ? { backgroundColor: "#f8f9fa", cursor: "not-allowed" } : {}}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          >
                            <option value="">-- Select Firm --</option>
                            {state.FirmMaster.map((f) => <option key={f.Id} value={f.Id}>{f.Name}</option>)}
                          </select>
                        </div>

                        <div className="col-md-6 mb-3 d-flex align-items-center mt-4">
                          <div className="form-check">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="IsNotInUse"
                              name="IsNotInUse"
                              checked={!!values.IsNotInUse}
                              onChange={(e) => setFieldValue("IsNotInUse", e.target.checked)}
                            />
                            <label className="form-check-label" htmlFor="IsNotInUse">
                              Not In Use
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="mt-3">
                        <button type="submit" className="btn btn-primary me-2" disabled={isSubmitting}>
                          {isSubmitting ? "Saving..." : "Save"}
                        </button>
                        {state.id > 0 && (
                          <button
                            type="button"
                            className="btn btn-danger me-2"
                            onClick={async () => {
                              if (window.confirm(`Are you sure you want to delete designation "${values.Name || state.id}"?`)) {
                                try {
                                  await Fn_DeleteData(dispatch, () => {}, Number(state.id), `${API_WEB_URLS.MASTER}/0/token/DesignationMaster`);
                                  toast.success("Designation deleted successfully");
                                  navigate("/DesignationMaster");
                                } catch (err) {
                                  console.error("Error deleting designation:", err);
                                }
                              }
                            }}
                          >
                            Delete
                          </button>
                        )}
                        <button
                          type="button"
                          className="btn btn-danger light"
                          onClick={() => navigate("/DesignationMaster")}
                        >
                          Cancel
                        </button>
                      </div>
                    </form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default AddEdit_DesignationMaster;
